import React from 'react';
import { projects } from '../data/profile';

const Projects = () => {
  return (
    <section id="work" className="section">
      <div className="container">
        <header className="section-head">
          <p className="eyebrow">Selected work</p>
          <h2>Products and projects worth opening.</h2>
          <p className="lede">
            Hackathon winners and shipped apps. Each card keeps the stack, the year, and only the links that exist.
          </p>
        </header>
        <div className="project-grid">
          {projects.map((project) => (
            <article className="project-card" key={project.title}>
              <div className="project-visual">
                {project.image ? (
                  <img src={project.image} alt="" />
                ) : (
                  <span className="project-mark">{project.title}</span>
                )}
              </div>
              <div className="project-copy">
                <div className="project-topline">
                  <span>{project.kicker}</span>
                  <span>{project.year}</span>
                </div>
                <h3>{project.title}</h3>
                {project.award && <p className="award">{project.award}</p>}
                <p>{project.description}</p>
                <div className="chip-row">
                  {project.stack.map((item) => (
                    <span className="chip" key={item}>
                      {item}
                    </span>
                  ))}
                </div>
                <div className="card-links">
                  {project.live && (
                    <a className="text-link" href={project.live} target="_blank" rel="noopener noreferrer">
                      Live site
                    </a>
                  )}
                  {project.github && (
                    <a className="text-link" href={project.github} target="_blank" rel="noopener noreferrer">
                      Source
                    </a>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
